import { environment } from './../../../../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConstantesService } from '../../../../../core/constantes/constantes.service';
import { Observable } from 'rxjs/Observable';
import { Powerbi } from '../../../../../core/modelos/powerbi';

@Injectable()
export class PowerBiService {

    constructor(private http: HttpClient, private constantes: ConstantesService) { }

    updatePowerBi(infome: Powerbi): Observable<any> {
        return this.http.put(environment.urlBase + 'powerBI/' + infome.id, infome, this.constantes.httpOptions);
    }

    addPowerBi(infome: Powerbi): Observable<any> {
        return this.http.post<Powerbi>(environment.urlBase + 'powerBI', infome, this.constantes.httpOptions);
    }

    deletePowerBi (id: number): Observable<any> {
        return this.http.delete(environment.urlBase + 'powerBI/' + id, this.constantes.httpOptions);
    }

}



// WEBPACK FOOTER //
// ./src/app/main/content/activos/components/powerbi-tabla/powerbi.service.ts